<ul class="menu-links">
	<li>
		<a [routerLink]="federationsPath" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
			<i class="menu-icon far fa-sitemap"></i>
			<span translate="Menu.Federations"></span>
		</a>
	</li>

	<li>
		<a [routerLink]="federationDetailPath" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
			<i class="menu-icon far fa-file-alt"></i>
			<span translate="Menu.FederationDetail"></span>
		</a>
	</li>

	<li>
		<a [routerLink]="federationDetailUsersPath" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
			<i class="menu-icon far fa-users"></i>
			<span translate="Menu.FederationDetailUsers"></span>
		</a>
	</li>
</ul>